import { Injectable } from "@angular/core";
import { TranslateService } from '@ngx-translate/core';
declare var require: any
const IntroJs = require("../../../node_modules/intro.js");

export enum GuidePage {
  claimSetting = 'GuideClaimSetting',
  workflowSetting = 'GuideWorkflowSetting',
  shiftDailySetting = 'GuideShiftDailySetting',
  leaveSetting = 'GuideLeaveSetting',
  overtimeSetting = 'GuideOvertimeSetting',
  bussinesTripSetting = 'GuideBussinesTripSetting',
  attendanceLocationSetting = 'GuideAttemndanceLocationSetting',
  workLocationSetting = 'GuideWorkLocationSetting',
  costCenterListSetting = 'GuideCostCenterListSetting',
  jobGradeListSetting = 'GuideJobGradeListSetting',
  orgStructSetting = 'GuideOrgStructListSetting',
  inviteYourTeam = 'GuideInviteYourTeam',
  surveySetting = 'GuideSurveySetting',
}

@Injectable()
export class AppGuideProviders {
  public guidePage = {

  }
  public isRunTourGuide: boolean = false;
  
  constructor(
    public translate: TranslateService,
    ) {
  }

  homeGuide(steps: any) {
    const intro = IntroJs.introJs();
    this.isRunTourGuide = true;

    intro.setOptions({
      steps: steps,
      showStepNumbers: false,
      showProgress: false,
      exitOnOverlayClick: false,
      skipLabel: this.translate.instant("Skip"),
      doneLabel: this.translate.instant("Done"),
      nextLabel: this.translate.instant("Next"),
      // prevLabel: this.translate.instant("Back"),
      overlayOpacity: "0.8"
    });
    return intro
  }

  homeTabs(steps: any, callback) {
    const intro = IntroJs.introJs();
    this.isRunTourGuide = true;

    intro.setOptions({
      steps: steps,
      showProgress: false,
      exitOnOverlayClick: false,
      doneLabel: this.translate.instant("Done"),
      nextLabel: this.translate.instant("Next"),
      prevLabel: this.translate.instant("Back"),
      overlayOpacity: "0.8",
    });
    intro.onbeforechange(function () {
      // if (this._currentStep === 4) {
      //   this.tab.select(4);
      // }
    });
    return intro
  }


  companySetup(steps: any) {
    const intro = IntroJs.introJs();
    this.isRunTourGuide = true;

    intro.setOptions({
      steps: steps,
      showStepNumbers: false,
      showProgress: false,
      exitOnOverlayClick: false,
      skipLabel: this.translate.instant("Skip"),
      doneLabel: this.translate.instant("Done"),
      nextLabel: this.translate.instant("Next"),
      // prevLabel: this.translate.instant("Back"),
      overlayOpacity: "0.8"
    });
    return intro
  }

  singleOnboarding(steps: any, page: string) {
    const storage = localStorage.getItem(page);
    if (!storage) {
      const intro = IntroJs.introJs();
      this.isRunTourGuide = true;
      intro.setOptions({
        steps: steps,
        showStepNumbers: false,
        showProgress: false,
        exitOnOverlayClick: false,
        showBullets: false,
        doneLabel: this.translate.instant("Got It"),
        overlayOpacity: "0.8"
      });
      localStorage.setItem(page, 'done');
      return intro;
    } else {
      return { start: () => { } };
    }
  }

  setStorageDone(guidePage: GuidePage) {
    localStorage.setItem(guidePage, 'done');
  }

  getStorageDone(guidePage: GuidePage) {
    return localStorage.getItem(guidePage);
  }

}




// WEBPACK FOOTER //
// ./src/providers/app-guide/appGuideProviders.ts